'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _keys = require('babel-runtime/core-js/object/keys');
var _keys2 = _interopRequireDefault(_keys);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
exports.default = function (dependencies) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'codesandboxer-example';
  var main = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'index.js';
  return '{\n  "name": "' + name + '",\n  "version": "0.0.0",\n  "description": "A simple example deployed using react-codesandboxer",\n  "main": "' + main + '",\n  "dependencies": {\n    ' + (0, _keys2.default)(dependencies).map(function (k) {
    return '"' + k + '": "' + dependencies[k] + '"';
  }).join(',\n    ') + '\n  }\n}';
};